import {
  BacteriaClassification,
  BacteriaAttentionCategory,
  BacteriaAttentionAction,
  ConditionBacteria,
  ReportSummary,
  BacteriaReport,
} from '@snapi/types';
import { ReportComparatorUtils } from './report-comparator-utils';

const extract = (
  bacteria: BacteriaReport[],
  condition: string[]
): ConditionBacteria[] => {
  return bacteria
    .filter(
      ({ threshold, percentage, protective }) =>
        threshold.classification === BacteriaClassification.other &&
        threshold.condition.some((concern) => condition.includes(concern)) &&
        ReportComparatorUtils.passesThreshold(
          percentage,
          threshold.comparator,
          threshold.threshold,
          protective
        )
    )
    .flatMap(
      ({
        threshold: {
          
          condition,
          research: { name, taxonomy },
          threshold,
          comparator,
          
        },
        percentage,
        protective
      }) => {
        return condition
          .filter((c) => condition.includes(c))
          .map<ConditionBacteria>((condition) => ({
            name,
            taxonomy,
            percentage,
            threshold,
            comparator,
            category: BacteriaAttentionCategory.condition,
            categoryType: protective === 0 ? 'disruptive' : 'protective',
            action:
              protective !== 0
                ? BacteriaAttentionAction.increase
                : BacteriaAttentionAction.decrease,
            condition,
          }));
      }
    );
};

const summary = (
  bacteria: BacteriaReport[],
  condition: string[]
): ReportSummary['condition'] => {
  return extract(bacteria, condition).reduce(
    (agg: ReportSummary['condition'], bac) => {
      if (agg[bac.condition]) {
        agg[bac.condition].push(bac);
      } else {
        agg[bac.condition] = [bac];
      }
      return agg;
    },
    {}
  );
};

export const ReportConditionUtils = {
  summary,
  extract,
};
